// © Microsoft Corporation. All rights reserved.

import { TelemetryBehaviorType, TelemetryObjectBase } from "@msnews/telemetry-contracts";

import { genericTelemetryClickDispatcher } from "../Social.telemetry";

export interface CommunityGuidelinesTelemetryObjects {
    guidelinesBtnAtPrinciples: TelemetryObjectBase;
    guidelinesBtnAtEnforcement: TelemetryObjectBase;
    enforcementBtn: TelemetryObjectBase;
    principlesBtn: TelemetryObjectBase;
    tabs: any;
}

export const communityGuidelinesTelemetryContracts = {
    /** Scenario 1 click tabs*/
    tabs: {
        Principles: { /** id: traceId */
            name: "Principles",
            behavior: TelemetryBehaviorType.Show,
            content: {
                headline: "Principles"
            }
        },
        Guidelines: { /** id: traceId */
            name: "Guidelines",
            behavior: TelemetryBehaviorType.Show,
            content: {
                headline: "Guidelines"
            }
        },
        Enforcement: { /** id: traceId */
            name: "Enforcement",
            behavior: TelemetryBehaviorType.Show,
            content: {
                headline: "Enforcement"
            }
        }
    },
    /** Scenario 2 and Scenario 4 click guidelines btn
     * name: active tab (enforceement/principles)
    */
    guidelinesBtn: {
        name: "Guidelines",
        behavior: TelemetryBehaviorType.Show,
        content: {
            headline: "Guidelines"
        }
    },
    /** Scenario 3 click enforcement btn on guidelines tab */
    enforcementBtn: {
        name: "Enforcement",
        behavior: TelemetryBehaviorType.Show,
        content: {
            headline: "Enforcement"
        }
    },
    /** Scenario 3 click principles btn on guidelines tab */
    principlesBtn: {
        name: "Principles",
        behavior: TelemetryBehaviorType.Show,
        content: {
            headline: "Principles"
        }
    }
};

export const communityGuidelinesTelemetryActionDispatchers = {
    /** Used for: Scenario 3a and Scenario 4a */
    genericClicked: genericTelemetryClickDispatcher
};